<template>
	<div class="account-buttons">
		<Profile
			v-if="loggedIn"
			:user="user"
			:imgProfile="imgProfile"
			@logout="logout"
		/>
		<template v-else>
			<button
				v-if="!isSmallDevice"
				:title="$t('LoginButtonTitleAttributeHeaderSignIn')"
				:aria-label="$t('LoginButtonAriaLabelHeaderSignIn')"
				class="sign-in"
				@click="openDialog('signIn')"
			>
				{{ $t("LoginButtonTextHeaderSignIn") }}
			</button>
			<button
				:title="$t('LoginButtonTitleAttributeHeaderGetStarted')"
				:aria-label="$t('LoginButtonAriaLabelHeaderGetStarted')"
				class="get-started"
				@click="openDialog('signUp')"
			>
				{{ $t("LoginButtonTextHeaderGetStarted") }}
				<span class="wficon-user-circle"></span>
			</button>
		</template>
		<sweet-modal ref="modal" @close="closeDialog" class="login-dialog">
			<p class="dialog-caption">
				{{ $t(modalContent[dialogType].title) }}
			</p>
			<p>{{ $t(modalContent[dialogType].text) }}</p>
			<button
				:aria-label="$t(modalContent[dialogType].btnAriaLabel)"
				:title="$t(modalContent[dialogType].btnTitle)"
				class="google-btn"
				@click="onLogin(dialogType)"
			>
				<span>
					<img
						src="/static-wf/images/google-logo.svg"
						alt="google-logo"
						width="16"
						height="16"
					/>
				</span>
				{{ $t(modalContent[dialogType].btnText) }}
			</button>
			<p>
				{{ $t(modalContent[dialogType].hint) }}
				<a
					href="#"
					@click.prevent="
						openDialog($t(modalContent[dialogType].name))
					"
				>
					{{ $t(modalContent[dialogType].hintLink) }}
				</a>
			</p>
			<span v-html="$t(modalContent[dialogType].disclaimerText)" />
			<a href="#" class="link" @click.prevent="onRemindButtonClick">
				{{ $t(modalContent[dialogType].remindeText) }}
			</a>
		</sweet-modal>
	</div>
</template>

<script>
import Profile from "@/components/profile";
import { SweetModal } from "sweet-modal-vue";
import { mapActions, mapGetters } from "vuex";

const modalContent = {
	signIn: {
		name: "signUp",
		title: "LoginDialogTitleSignIn",
		text: "LoginDialogText1SignIn",
		btnText: "LoginButtonTextSignIn",
		btnAriaLabel: "LoginButtonAriaLabelSignIn",
		btnTitle: "LoginButtonTitleAttributeSignIn",
		hintLink: "LoginDialogTextSignIn",
		disclaimerText: "LoginDialogLegalDisclaimerSignIn",
		remindeText: "LoginDialogText3SignUp",
		eventDialogAction: "Click on header sign in button",
		eventDialogID: 39,
		eventLoginAction: "Click on Google sign in button",
		eventLoginID: 37,
		eventLabel: "LoginButtonTextHeaderSignIn",
	},
	signUp: {
		name: "signIn",
		title: "LoginDialogTitleSignUp",
		text: "LoginDialogText1SignUp",
		btnText: "LoginButtonTextSignUp",
		btnAriaLabel: "LoginButtonAriaLabelSignUp",
		btnTitle: "LoginButtonTitleAttributeSignUp",
		hint: "LoginDialogText2SignUp",
		hintLink: "LoginButtonTextHeaderSignIn",
		disclaimerText: "LoginDialogLegalDisclaimerSignUp",
		remindeText: "LoginDialogText3SignUp",
		eventDialogAction: "Click on header sign up button",
		eventDialogID: 40,
		eventLoginAction: "Click on Google sign up button",
		eventLoginID: 38,
		eventLabel: "LoginButtonTextHeaderGetStarted",
	},
};
export default {
	name: "AccountButtons",
	components: {
		SweetModal,
		Profile,
	},
	data() {
		return {
			modalContent,
		};
	},
	watch: {
		isDialogOpen: "toggleDialog",
	},
	computed: {
		...mapGetters([
			"isDialogOpen",
			"dialogType",
			"user",
			"loggedIn",
			"imgProfile",
		]),
	},
	methods: {
		...mapActions(["login", "logout", "openDialog", "closeDialog"]),
		onOpenDialog() {
			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Login",
				eventAction: modalContent[this.dialogType].eventDialogAction,
				eventLabel: modalContent[this.dialogType].eventLabel,
				eventID: modalContent[this.dialogType].eventDialogID,
			});
		},
		onLogin(type) {
			this.login();

			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Login",
				eventAction: modalContent[type].eventLoginAction,
				eventLabel: modalContent[type].btnText,
				eventID: modalContent[type].eventLoginID,
			});
		},
		onRemindButtonClick() {
			this.remindButtonClick = true;
			this.$refs.modal.close();
			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "Login",
				eventAction: "Click on Remind me later button",
				eventLabel: "LoginDialogText3SignUp",
				eventID: 41,
			});
		},
		onCloseDialog() {
			if (!this.remindButtonClick) {
				this.$store.dispatch("trackEvent", {
					ga: this.$ga,
					eventCategory: "Login",
					eventAction: "Click on sign in cross icon",
					eventID: 43,
				});
			}
			this.remindButtonClick = false;
		},
		toggleDialog(val) {
			if (val) {
				this.$refs.modal.open();
				this.onOpenDialog();
			} else {
				this.$refs.modal.close();
				this.onCloseDialog();
			}
		},
		async getFirebaseClient() {
			const firebase = await import("firebase/app");
			await import("firebase/auth");
			let firebaseConfig = await import("@/firebaseConfig");

			firebase.initializeApp(firebaseConfig.default);

			return firebase;
		},
	},
	created() {
		if (
			typeof window.__PRERENDER_INJECTED === "undefined" &&
			typeof window.__TEST__ === "undefined"
		) {
			this.getFirebaseClient()
				.then((firebase) => {
					firebase.auth().onAuthStateChanged((user) => {
						this.$store.dispatch("fetchUser", user);
					});
				})
				.catch(console.log);
		}
	},
};
</script>

<style lang="scss" scoped src="./styles.scss"></style>
